import React, { useContext } from 'react'
import { useQuery } from '@apollo/client'
import { GET_TASK_STATUSES } from '../queries'

const TaskStatusContext = React.createContext()

function TaskStatusProvider({ children }) {
  const { loading, data } = useQuery(GET_TASK_STATUSES)
  const { taskStatuses } = data || {}

  return (
    <TaskStatusContext.Provider
      value={{
        loading,
        taskStatuses,
      }}
    >
      {children}
    </TaskStatusContext.Provider>
  )
}

function useTaskStatuses() {
  return useContext(TaskStatusContext)
}

export { TaskStatusProvider, useTaskStatuses }
